import React from 'react';
import Panel from '../components/Panel';
import {connect} from 'react-redux';
import './BlueprintReviewPanel.scss';
import _ from 'lodash';
import BlueprintPanelFooter from '../blocks/BlueprintPanelFooter';
import * as actions from '../store/actions/index';
import store from '../store';
import languages from '../lib/languages';
import InputDayPicker from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import moment from 'moment';

class BlueprintReviewPanel extends React.Component {

  constructor(props) {
    super(props);

    let values = props.blueprint.values || {};
    this.state = {
      data: _.reduce(props.block.fields, (container, field) => {
        let name = `${props.block.name}.${field.name}`;
        if (_.isEmpty(values[name])) {
          container[name] = {
            data: field.defaultValue,
          };
        } else {
          container[name] = values[name];
        }
        return container;
      }, {}),
      dirtyFields: new Set(),
    };

    this.user = props.user;

    this.handleNext = this.handleNext.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  finalizeData() {
    let userName = this.user.nickname || this.user.id;
    let {block, blueprint} = this.props;
    let commentAction = this.user.isAdmin ?
        'ancileocomments' :
        'clientcomments';

    let newAudit = _.reduce(Array.from(this.state.dirtyFields),
        (container, dirtyField) => {
          let field = _.find(block.fields,
              (item) => `${block.name}.${item.name}` === dirtyField);

          container[dirtyField] = {
            update: {
              action_date: new Date(),
              by: userName,
              details: `You have received a new comment from ${userName} on task  ${field.label} in the group ${block.title} for project ${blueprint.name}.\nComment: ${this.state.data[dirtyField][commentAction]}`,
            },
          };
          return container;
        }, {});

    return {
      data: _.reduce(this.state.data, (container, value, key) => {
        if (!_.isEmpty(value)) {
          container[key] = value;
        }
        return container;
      }, {}),
      audit: newAudit,
    };
  }

  handleNext() {
    let {data, audit} = this.finalizeData();
    this.props.onNext(data, audit);
  }

  handleSubmit() {
    let {data, audit} = this.finalizeData();
    this.props.onSubmit(data, audit);
  }

  handleFormComments(name, action, e) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        [name]: Object.assign({}, this.state.data[name], {
          [action]: e.target.value,
          audit: {
            action,
            action_date: new Date(),
            by: this.props.user.id,
          },
        }),
      }),
      dirtyFields: this.state.dirtyFields.add(name),
    });
  }

  handleApprovalChange(name, e) {
    this.setState({
      data: Object.assign({}, this.state.data, {
        [name]: Object.assign({}, this.state.data[name], {
          approved: e.target.checked,
        }),
      }),
    });
  }

  handleDueDateChange(name, date) {
    console.log([name, date]);
    this.setState({
      data: Object.assign({}, this.state.data, {
        [name]: Object.assign({}, this.state.data[name], {
          duedate: date,
        }),
      }),
    });
  }

  renderFieldValue(value, type, options = {}) {

    if (['select', 'multi-select'].includes(type)) {
      options =
          _.isObject(options) ?
              options :
              _.transform(options, (container, item) => {
                container[item.value] = item.label;
                return container;
              }, {});
    }

    switch (type) {
      case 'multi-text':
        value = value || [];
        value = _.isArray(value) ? value : [{label: value, value}];
        value = _.map(value, (item) => item.label).join(', ');
        return _.isEmpty(value) ?
            (<span className="placeholder">None provided</span>) :
            (<span>{value}</span>);
      case 'multi-select':
        value = _.map(value || [], (item) => item.label).
            join(', ');
        return _.isEmpty(value) ?
            (<span className="placeholder">None provided</span>) :
            (<span>{value}</span>);
      case 'select':
        value = value ? value.label : null;
        return _.isEmpty(value) ?
            (<span className="placeholder">None provided</span>) :
            (<span>{value}</span>);
      case 'multi-file':
      case 'file':
        return (_.isEmpty(value) ?
            (<span className='placeholder'>No file selected</span>) :
            (<ul style={{listStyle: 'circle inside'}}>
              {
                (_.isArray(value) ? value : [value]).map((file, index) => {
                  return (<li key={'multi-file-' + index}
                              style={{listStyle: 'circle inside'}}><a
                      href={file.url} target="_blank">{file.name}</a></li>);
                })
              }
            </ul>));
      case 'translated-field-file':
        return (_.reduce(value, (container, value, index) => {
          let code = value.lng;
          let file = value.val[0];
          if(!file) return container;
          if (index !== 0) {
            container.push(<span key={code + '_space'}>,&nbsp;</span>);
          }
          container.push(
              <a href={file.url} key={code}>{code in languages ?
                  languages[code] :
                  code}</a>);
          return container;
        }, []));

      case 'translated-field-text':
        return (_.reduce(value, (container, value, index) => {
          let code = value.lng;
          container.push(
              <span key={code}>{code in languages ?
                  languages[code] :
                  code}:<br/> <strong>{value.val}</strong><br/></span>);
          return container;
        }, []));
      default:
        return _.isEmpty(value) ?
            (<span className="placeholder">None provided</span>) :
            (<span>{value}</span>);
    }
  }

  renderField({name, type, label, options = {}}) {
    name = `${this.props.block.name}.${name}`;
    let field = this.state.data[name] || {};
    let value = field.data;
    let dateSubmitted = !field.submitted ?
        null :
        new Date(field.submitted).toLocaleDateString();
    let daysDelayed = null;
    let status = !value ? null : (field.approved ? 'Approved' : 'Pending');
    let dueDate = field.duedate ? new Date(field.duedate) : new Date();
    if (field.duedate) {
      let referenceDate = field.submitted ?
          new Date(field.submitted) :
          new Date();
      daysDelayed = moment(referenceDate).
          diff(moment(new Date(field.duedate)), 'days');
    }

    return (
        <div className="field-row" key={name}>
          <div className="field-header-row row no-gutters">
            <div className="col-md-3 not-centered">
              <span>{label}</span>
            </div>
            <div className="col-md-3 row px-0 no-gutters">
              <div className="col-md-6">
                <span>Due Date</span>
              </div>
              <div className="col-md-6">
                <span>Submitted Date</span>
              </div>
            </div>
            <div className="col-md-1">
              <span>Days Delayed</span>
            </div>
            <div className="col-md-2">
              <span>Status</span>
            </div>
            <div className="col-md-3 not-centered">
              <span>Comments</span>
            </div>
          </div>
          <div className="field-value-row row no-gutters">
            <div className="col-md-3 not-centered field-value">
              {this.renderFieldValue(value, type, options)}
            </div>
            <div className="col-md-3 row px-0 no-gutters">
              <div className="col-md-6  due-date-picker">
                {
                  this.user.isAdmin ?
                      (
                          <InputDayPicker
                              value={dueDate}
                              onDayChange={this.handleDueDateChange.bind(this,
                                  name)}
                          />
                      ) : (
                          <span>{field.duedate ?
                              dueDate.toLocaleDateString() :
                              null}</span>
                      )
                }
              </div>
              <div className="col-md-6">
                {!dateSubmitted ? null : (<span>{dateSubmitted}</span>)}
              </div>
            </div>

            <div className="col-md-1">
              <span>{daysDelayed > 0 ? daysDelayed : null}</span>
            </div>
            <div className="col-md-2 d-flex justify-content-center">
              {
                this.user.isAdmin && value ? (
                    <fieldset className="">
                      <input type="checkbox"
                             id={`approve_${name}`}
                             defaultChecked={field.approved}
                             onChange={this.handleApprovalChange.bind(this,
                                 name)}
                      />
                      <label className="checkbox" htmlFor={`approve_${name}`}>
                        Approve
                      </label>
                    </fieldset>
                ) : (<span>{status}</span>)
              }

            </div>
            <div className="col-md-3 not-centered">
              <h6>Client Comments</h6>
              <textarea className='field-wrap'
                        disabled={this.user.isAdmin}
                        defaultValue={this.state.data[name].clientcomments}
                        onChange={!this.user.isAdmin ?
                            this.handleFormComments.bind(this,
                                name,
                                'clientcomments') :
                            null}
              />
              <h6>Ancileo Comments</h6>
              <textarea className='field-wrap'
                        disabled={!this.user.isAdmin}
                        defaultValue={this.state.data[name].ancileocomments}
                        onChange={this.user.isAdmin ?
                            this.handleFormComments.bind(this,
                                name,
                                'ancileocomments') :
                            null}
              />
            </div>
          </div>
        </div>
    );
  }

  render() {
    return (
        <Panel title={this.props.block.title}
               className="BlueprintReviewPanel"

        >
          {(() => {
            return this.props.block.fields.map((field) => {
              return this.renderField(field);
            });
          })()}
          <BlueprintPanelFooter
              submitting={this.props.submitting}
              onNext={this.props.onNext ? this.handleNext : null}
              onBack={this.props.onBack}
              onSubmit={this.props.onSubmit ? this.handleSubmit : null}
          />
        </Panel>
    );
  }
}

export default connect((state, props) => {
  return {
    blueprint: Object.assign({}, props.blueprint || {},
        (state.blueprints.current || {})),
  };
})(BlueprintReviewPanel);


// WEBPACK FOOTER //
// ./src/containers/BlueprintReviewPanel.js